













import Vue from 'vue';
import CookieHelper from '@/helpers/CookieHelper';
import RemoteDataSelectInput from './RemoteDataSelectInput.vue';
import { EInputIdentifier } from '../../../common/enums/input-identifier.enum';

export default Vue.extend({
  components: {
    RemoteDataSelectInput,
  },
  model: {
    event: `change`,
    prop: `value`,
  },
  data(): { language: string } {
    return {
      language: CookieHelper.getLanguage(),
    };
  },
  props: {
    identifier: {
      default: ``,
      type: String as () => EInputIdentifier,
    },
    t: {
      required: true,
      type: Object as () => Record<string, string>,
    },
    testSelector: {
      default: ``,
      type: String,
    },
    title: {
      default: ``,
      type: String,
    },
    value: {
      default: `0`,
      type: [String, Number],
    },
  },
});
